import { useState, useCallback } from 'react';
import ConfirmModal from '../components/ConfirmModal/ConfirmModal';

interface ConfirmOptions {
  title?: string;
  message?: string;
  description?: string;
}

export const useConfirm = () => {
  const [confirmState, setConfirmState] = useState<{
    isOpen: boolean;
    title?: string;
    message?: string;
    description?: string;
    onConfirm: () => void;
  } | null>(null);

  const confirm = useCallback((options: ConfirmOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title: options.title,
        message: options.message,
        description: options.description,
        onConfirm: () => {
          setConfirmState(null);
          resolve(true);
        },
      });
    });
  }, []);

  const handleCancel = useCallback(() => {
    setConfirmState(null);
  }, []);

  const ConfirmDialog = useCallback(() => {
    if (!confirmState || !confirmState.isOpen) return null;

    return (
      <ConfirmModal
        title={confirmState.title}
        message={confirmState.message}
        description={confirmState.description}
        onConfirm={confirmState.onConfirm}
        onCancel={handleCancel}
      />
    );
  }, [confirmState, handleCancel]);

  return {
    confirm,
    ConfirmDialog,
  };
};
